import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { closeDrawer, openExamDirect } from '../../helpers/helpers';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

const SessionStartHybrid = observer(
  class SessionStartHybrid extends React.Component {
    constructor() {
      super();

      // Set the initial state
      this.state = {
        late: false,
        early: false
      };
    }

    componentDidMount() {
      const { exam, store } = this.props;
      const { installSid } = store.SessionStore.userData
      const { examSession } = exam;

      openExamDirect(installSid, exam.sid, examSession.sid)
      .then(response => {
        this.checkTime(response.redirectUrl);
      })
    }

    checkTime = (examUrl) => {
      const { exam } = this.props;
      const { examSession } = exam;

      const now = moment(this.props.store.SessionStore.currentTime);
      const sessionTime = moment(examSession.appointmentDate);
      const timeToSession = moment.duration(sessionTime.diff(now)).asMinutes();
      const sessionEnd = moment(examSession.appointmentDate).add(30, 'minutes');
      const timeToSessionEnd = moment.duration(sessionEnd.diff(now)).asMinutes();

      const late = timeToSessionEnd <= 0;
      const early = timeToSession >= 10;

      if(late || early) {
        this.setState({
          late,
          early
        });
      } else {
        window.open(examUrl, '_top');

        closeDrawer(null, this.props.parent);
      }
    }

    render() {
      const { exam, store, translation } = this.props;
      const { early, late } = this.state;
      const { examSession } = exam;
      const { userTimezone } = store.SessionStore;

      if (late) {
        return (
          <div className="slide-wrap wrap">
            <div
              className="panel panel--brief slide-active"
            >
              <h2 className="panel__title">{translation.late.heading}</h2>

              <p>{translation.late.body.replace('%date%', moment.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))}</p>

              <button
                className="btn"
                onClick={(e) => { closeDrawer(e, this.props.parent) }}
              >
                {translation.late.button}
              </button>
            </div>
          </div>
        )
      } else if(early) {
        return (
          <div className="slide-wrap wrap">
            <div className="panel panel--brief slide-active">
              <h2 className="panel__title">{translation.early.heading}</h2>

              <p>{translation.early.body.replace('%date%', moment.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))}</p>

              <button
                className="btn"
                onClick={(e) => { closeDrawer(e, this.props.parent) }}
              >
                {translation.early.button}
              </button>
            </div>
          </div>
        )
      }

      return null;
    }
  }
);

export default translate('SessionStartHybrid')(SessionStartHybrid);



// WEBPACK FOOTER //
// ./src/app/components/SessionStart/SessionStartHybrid.js